// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    apiurl: 'https://apis-dev-sprynt.arghyac35.dev/api/',
//   apiurl: 'http://localhost:3000/api/',
};
